<template>
    <v-container fluid>
      <AnexoConab v-if="$store.state.emp.cod_empresa == 383" />
      <AnexoVeinti  v-else-if="$store.state.emp.cod_empresa == 496" />
      <AnexoConsultoria v-if="$store.state.emp.cod_empresa == 475" />
      <AnexoAna v-if="$store.state.emp.cod_empresa == 602" />
      <AnexoGomez v-if="$store.state.emp.cod_empresa == 601" />
      <AnexosWalter v-if="$store.state.emp.cod_empresa == 474" />
      <AnexoLibreria v-if="$store.state.emp.cod_empresa == 600" />
      <AnexosSuc v-if="$store.state.emp.cod_empresa == 494" />
      <AnexosAbel v-if="$store.state.emp.cod_empresa == 476" />
      <AnexosSwisstex v-if="$store.state.emp.cod_empresa == 381" />
      <AnexosUnique v-if="$store.state.emp.cod_empresa == 380" />
      <AnexosCarlos v-if="$store.state.emp.cod_empresa == 483" />
      <AnexosJadip v-if="$store.state.emp.cod_empresa == 493" />
      <AnexosJadip v-if="$store.state.emp.cod_empresa == 48" />
      <AnexosBilly v-if="$store.state.emp.cod_empresa == 473" />

    </v-container>
  </template>
  
  <script>

  import AnexoConab from './Conab/AnexoConab.vue';
  import AnexoVeinti from './Veintinueve/AnexoVeinti.vue';
  import AnexoConsultoria from './Consultoria/AnexoConsultoria.vue';
  import AnexoAna from './AnaCecilia/AnexoAna.vue';
  import AnexoGomez from './DrGomez/AnexoGomez.vue';
  import AnexosWalter from './Walter/AnexosWalter.vue'; 
  import AnexoLibreria from './Libreria/AnexoLibreria.vue';
  import AnexosSuc from './Suc/AnexosSuc.vue';
  import AnexosAbel from './Abel/AnexosAbel.vue';
  import AnexosSwisstex from './Swisstex/AnexosSwisstex.vue';
  import AnexosUnique from './Unique/AnexosUnique.vue';
  import AnexosCarlos from './CarlosNieto/AnexoCarlos.vue';
  import AnexosJadip from './Jadip/AnexoJadip.vue';
  import AnexosWilliam from './William/AnexosWilliam.vue';
  import AnexosBilly from './Billy/AnexoBilly.vue';

  export default {
    data: () => ({
      //
    }),
    components: {
        AnexoConab,
        AnexoVeinti,
        AnexoConsultoria,
        AnexoAna,
        AnexoGomez,
        AnexosWalter,
        AnexoLibreria,
        AnexosSuc,
        AnexosAbel,
        AnexosSwisstex,
        AnexosUnique,
        AnexosCarlos,
        AnexosJadip,
        AnexosWilliam,
        AnexosBilly
    },
  };
  </script>